module.exports = __webpack_public_path__ + "static/img/home41.d9be949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home41.png
// module id = UIHx
// module chunks = 13